module.exports = __webpack_public_path__ + "img/topBG1.ca9c5efa.png";